module.exports = __webpack_public_path__ + "static/apple-icon-60x60-c3f545f6c8b578bae69272c39089e9bf.png";